import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ValeurListeFixeModel} from '../../models/listes-fixes/valeur-liste-fixe.model';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root',
})
export class ListeFixeCategoriesTacheService {
  private readonly baseUrlApi = `${this.configService.config.urlApi}/api/g`;

  constructor(private client: HttpClient, private configService: ConfigService) {}

  getValeurs(): Observable<Array<ValeurListeFixeModel>> {
    return this.client.get<Array<ValeurListeFixeModel>>(`${this.baseUrlApi}/ListeFixeCategoriesTache/getValeurs`);
  }
}
